﻿//fix double databound EditClient ¯\_(ツ)_/¯
let first: boolean;

function setFirst(value: boolean) {
    first = value;
}

function getFirst() {
    return first;
}

function loadModel() {
    setTimeout(loader, 100);
}

function loader() {
    if ($('.k-i-loading:not(.k-hidden)').length !== 0) {
        loadModel();
    }
    else if (getFirst()) {
        setFirst(false);
        loadModel();
    }
    else {
        initModel();
    }
}

function initModel() {
    window.modelJs = {};

    $(':input[class*=k-textbox][name],:input[class*=k-input][name]').each(function () {
        const control = this as HTMLInputElement;
        const combo = $(`#${control.name.replace('_input', '')}`).data('kendoComboBox');
        window.modelJs[control.name.replace('_input', '')] = !combo ? $(this).val() : combo.value();
    });

    $('[data-role=multiselect]').each(function () {
        const control = this as HTMLInputElement;
        window.modelJs[control.name] = $(this).data('kendoMultiSelect')?.value();
    });
}

function entityGetChangedFields() {
    const change: Record<string, string> = {};

    $(':input[class*=k-textbox][name],:input[class*=k-input][name]').each(function () {
        const control = this as HTMLInputElement;
        const combo = $(`#${control.name.replace('_input', '')}`).data('kendoComboBox');
        const currentValue = !combo ? $(this).val() : combo.value();

        if (window.modelJs[control.name.replace('_input', '')] !== currentValue) {
            change[control.name.replace('_input', '')] = window.modelJs[control.name.replace('_input', '')];
        }
    });

    $('[data-role=multiselect]').each(function () {
        const control = this as HTMLInputElement;
        const value = $(control).data('kendoMultiSelect')?.value();

        if (value.length !== window.modelJs[control.name].length) {
            change[control.name] = window.modelJs[control.name];
        }
        else {
            for (let i = 0; i < value.length; i++) {
                if (value[i] !== window.modelJs[control.name][i]) {
                    change[control.name] = window.modelJs[control.name];
                    break;
                }
            }
        }
    });

    return change;
}

function entityIsChanged() {
    return Object.keys(entityGetChangedFields()).length !== 0;
}

window.loadModel = loadModel;
window.setFirst = setFirst;
window.getFirst = getFirst;
window.initModel = initModel;
window.loader = loader;
window.entityGetChangedFields = entityGetChangedFields;
window.entityIsChanged = entityIsChanged;